import { BlogArticleFrontMatter } from '@prishapolicy/markdown';
import { getTextFromHtml, slugify, useWindowWidth } from '@prishapolicy/shared/ui';
import Image from 'next/image';

import { Badge } from '@prishapolicy/shared/ui';
import Link from 'next/link';
export const BlogCardGrid = ({
  items = [],
  maxPerRow = 4,
}: {
  items: BlogCardProps['item'][];
  maxPerRow?: number;
  BlogCardPrefix: string;
}) => {
  const { isLg } = useWindowWidth();
  maxPerRow = !isLg ? 2 : maxPerRow;
  const groups = items
    .map(function (_, i) {
      return i % maxPerRow === 0 ? items.slice(i, i + maxPerRow) : [];
    })
    .filter(function (e) {
      return e;
    });

  return (
    <div className="bg-surface-grey pb-14">
      <div className="container">
        <div>
          {groups.map((group, idx) => {
            return (
              group.length > 0 && (
                <div
                  key={idx}
                  className={`my-4 flex flex-col gap-y-4 gap-x-4 lg:grid grid-cols-${Math.min(
                    maxPerRow,
                    group.length,
                  )}`}
                >
                  {group.map((item, idx) => {
                    return <BlogCardTemplate key={idx} item={item} />;
                  })}
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

type BlogCardProps = {
  item: {
    name: string;
    linkPath?: string;
    image?: string;
    tag?: string;
  };
};

export const BlogCardTemplate = (props: BlogCardProps) => {
  const { isLg } = useWindowWidth();
  return (
    <div
      style={{
        minHeight: isLg ? '200px' : '',
      }}
      className={`flex flex-1 flex-col ${
        props.item.image ? 'justify-between' : 'justify-end'
      } rounded-large border-grey-200 hover:border-primary cursor-pointer border-2 bg-white p-6 transition duration-300 ease-in-out hover:-translate-y-3 hover:drop-shadow-[-5px_5px_0_rgba(39,55,140,0.5)]`}
      onClick={() => {
        window.location.href = `/resources/blog/${slugify(getTextFromHtml(props.item.name))}`;
      }}
    >
      {props.item.image && <Image src={props.item.image} style={{ height: 48, width: 48 }} alt={props.item.name} />}
      <h4 className="lg:heading-4 heading-6" dangerouslySetInnerHTML={{ __html: props.item.name }}></h4>
    </div>
  );
};

export const BlogVerticalCard = ({
  size = 'small',
  blog,
}: {
  size?: 'small' | 'large';
  blog: BlogArticleFrontMatter;
}) => {
  return (
    <Link href={blog.pressArticleLink ? blog.pressArticleLink : `/resources/blog/${blog.slug}`} legacyBehavior>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a className={`min-w-[70vw] md:min-w-[50vw] xl:min-w-[400px]`}>
        <div className={`bg-surface-grey rounded-large z-5 relative h-full cursor-pointer `}>
          <div className="h-[300px] lg:h-[344px]" style={{ width: '100%', position: 'relative', overflow: 'hidden' }}>
            <Image
              src={
                blog.pressArticleLink
                  ? `/press-assets/${blog.imageName}.png`
                  : `/blog-assets/${blog.slug}/thumbnail.png`
              }
              alt={blog.imageName || blog.slug || 'big blog'}
              sizes="(max-width:1400px) 70vw, 40vw"
              fill
              style={{
                objectFit: 'cover',
              }}
            />
          </div>
          <div className="relative  p-6">
            <div className="mb-2 flex items-center">
              <Badge text={blog.tags[0]} />
              <p className="ml-3 flex-1">
                {blog.minutesToRead ? `${blog.minutesToRead} min read` : blog.pressArticleLinkLabel}
              </p>
            </div>
            <h3 className={`${size === 'large' ? 'heading-6' : 'heading-5 leading-tight'}`}>{blog.title}</h3>
            <p className={`${size === 'large' ? 'lg:text-title-6 text-body-3' : ''}`}>{blog.description}</p>
          </div>
        </div>
      </a>
    </Link>
  );
};
